$(document).ready(function(){

/*==============================================================
 Cart backdrop - trigger close cart
 ==============================================================*/

  $('#trigger-contact').click(function(){
  $('.ztb-cf-tabbutton').trigger('click');
  });
  
  
 /*===================================================================
  Prevent 'checking out' before picking a delivery date
 =====================================================================*/
  
  if ($('body').hasClass('template-cart')){ 
 
  // First load
  if($('input#date').val().length === 0){
       $('div.additional-checkout-buttons').addClass("no-click"); 
       $('input.cart-checkout.button').addClass("no-click");
       $('input#date').addClass("date-error");
  }
  
  // Datepicker dropdown selection
  $('#date').change(function () {
      
    if($('input#date').val().length !== 0){
         $('div.additional-checkout-buttons').removeClass("no-click");
         $('input.cart-checkout.button').removeClass("no-click");
         $('input#date').removeClass("date-error");
    } 
   
    });
  
  // Datepicker input field
  $("input#date").on("keyup", function (event) {
    
    if($('input#date').val().length === 0){
       $('div.additional-checkout-buttons').addClass("no-click"); 
       $('input.cart-checkout.button').addClass("no-click");
       $('input#date').addClass("date-error");
    }
  
  
  });
    
  }
  

});// End ready


  